import React from "react";
import PropTypes from "prop-types";

const LeftAlignedCheckbox = ({ label, input }) => (
  <span>
    <label
      style={{
        cursor: "pointer",
        fontSize: "1.15em",
        display: "inline-flex",
        paddingRight: 20
      }}
    >
      <input
        type="checkbox"
        style={{ margin: "0px 10px 0px 0px" }}
        {...input}
        checked={input.value}
      />
      {label}
    </label>
  </span>
);

LeftAlignedCheckbox.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object
};

export default LeftAlignedCheckbox;
